export default "__VITE_ASSET__DtZqytOR__"